import * as React from 'react';
import { TextField } from '@material-ui/core';
import { TextFieldProps } from 'material-ui'

import NumberFormat from 'react-number-format';
import { extend } from 'lodash'

interface Props extends TextFieldProps {
	integer?: boolean
	currency?: boolean
	onNumberChange: (value: number | undefined) => void;
	max?: number;
	error?: any;
	helperText?: any;
	InputLabelProps?: any;
	inputRef?: any;
	InputProps?: any;
	label?: any;
	margin?: any;
	style?: any;
	precision?: any;
	isKeyField?: boolean;
}

// ATTENTION: this is the max value for postgres int4
const POSTGRES_MAX_INT = 2147483647

type State = {
	value: any;
	dirtyWithZero?: boolean;
};

class NumberField extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props, {});
		this.state = {
			value: this.props.value
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps: Props) {
		if (nextProps.value != this.state.value) {
			this.setState({
				value: nextProps.value
			})
		} else if (nextProps.value == "") {
			// This is to make the clearing of the field work
			this.setState({
				dirtyWithZero: false
			})
		}
	}

	handleChange = (event: any): void => {
		const val = event.target.value as string;

		// if(val == ".00" || val == "-.00" || val == "-" || val == "0.00" || val == ".00" || val == ".000" || val == ".0000") {
		if (val.match(/[-]?\.[0]+/) && Number(val) == 0) {
			this.setState({
				value: val,
				dirtyWithZero: Number(val) == 0
			}, () => {
				if (Number(val) == 0) {
					this.props.onNumberChange(0);
				}
			})
		} else {
			let m = val.match(/^([-])?\d*(?:\.\d*)?$/g);
			if (this.props.integer) {
				m = val.match(/^([-])?\d*$/g);
			}
			if (m) {
				if (Number(val) <= (this.props.max || POSTGRES_MAX_INT)) {
					this.setState({ value: val, dirtyWithZero:false }, () => {
						try {
							// If this is a number, we can report it up the chain
							var nval = parseFloat(val);
							if (isNaN(nval)) {
								this.props.onNumberChange(undefined);
							} else {
								this.props.onNumberChange(nval);
							}
						} catch (e) {
							// So not a number, so send null
							this.props.onNumberChange(undefined);
						}
					});
				}
			}
		}
	};

	NumberFormatCustom = (props: any) => {
		const { inputRef, onChange, integer, ...other } = props;
		const decimalPrecision = this.props.precision || 2
		return (
			<NumberFormat
				{...other}
				ref={inputRef}
				onValueChange={(values: any) => {
					onChange({
						target: {
							value: values.value,
						},
					});
				}}
				isAllowed={(values: any) => {
					return (values.value == "-") || (values.value == ".") || (values.value <= (this.props.max || POSTGRES_MAX_INT))
				}}
				thousandSeparator
				decimalScale={decimalPrecision}
				fixedDecimalScale={this.props.currency}
			/>
		);
	}

	render() {
		const {
			className,
			style,
			disabled,
			error,
			helperText,
			id,
			InputLabelProps,
			inputRef,
			InputProps,
			label,
			name,
			placeholder,
			required,
			type,
			margin,
			onBlur,
			currency,
			onKeyDown,
			precision,
			isKeyField
		} = this.props;
		const { value, dirtyWithZero } = this.state;

		var ip = InputProps ? extend({}, InputProps) : {}

		if (currency || precision) {
			ip.inputComponent = this.NumberFormatCustom
		}
	
		return (
			<TextField
				className={className}
				style={style}
				fullWidth
				disabled={disabled}
				error={error}
				helperText={helperText}
				id={id}
				InputLabelProps={InputLabelProps}
				InputProps={ip}
				inputRef={inputRef}
				label={<span>{label}{isKeyField && !required && <i style={{color: "#CD5C5C", marginLeft: 5}} className="fa fa-key"></i>}</span>}
				name={name || id}
				placeholder={placeholder}
				required={required}
				type={type}
				margin={margin}
				value={value || (dirtyWithZero ? '0.00' : '')}
				onChange={this.handleChange}
				onBlur={onBlur}
				onKeyDown={onKeyDown}
			/>
		);
	}
}

export default NumberField;
